module.exports = __webpack_public_path__ + "img/calendar2.6d143789.svg";